'use client'

const getPlatformEventsBaseUrl = async (): Promise<string | undefined> => {
    const response = await fetch('/api/config', {
        method: 'GET',
    })
    const { envVariables } = (await response.json()) ?? {}

    return envVariables?.NEXT_PUBLIC_SSE_CLIENT_URL
}

const buildPlatformEventsUrl = (baseUrl: string, scope?: string, code?: string): string => {
    return scope && code ? `${baseUrl}/${scope}/${code}` : baseUrl
}

export const resolvePlatformEventsUrl = async (scope?: string, code?: string): Promise<string | undefined> => {
    const baseUrl = await getPlatformEventsBaseUrl()
    if (!baseUrl) {
        throw new Error('could not get platform events base url')
    }

    return buildPlatformEventsUrl(baseUrl, scope, code)
}
